<div
	class="service-catalog-container"
	*ngIf="!isLoadingLabels && !isLoadingCustomerData && !isLoadingCategory && !isLoadingQuestion && !isLoadingTemplate && !isLoadingKb">
	<div class="header-wrap">
		<span
			class="tab"
			[ngClass]="{ selected: selectedTab === 'category' }"
			(click)="
				unsavedCategoryChanges ? notifyUnsavedChanges() : (selectedTab = 'category');
				unsavedCategoryChanges ? (unsavedCategoryChanges = false) : resetCategory()
			"
			>{{ labels.lbl_asset_category }}</span
		>
		<span
			class="tab"
			[ngClass]="{ selected: selectedTab === 'question' }"
			(click)="
				unsavedQuestionChanges ? notifyUnsavedChanges() : (selectedTab = 'question');
				unsavedQuestionChanges ? (unsavedQuestionChanges = false) : resetQuestion()
			"
			>{{ labels.lbl_geral_questions }}</span
		>
		<span class="tab selected-2" *ngIf="selectedTab === 'answer'">{{ labels.lbl_geral_responses }}</span>
		<span
			class="tab"
			[ngClass]="{ selected: selectedTab === 'link' }"
			(click)="
				unsavedQuestionChanges ? notifyUnsavedChanges() : (selectedTab = 'link');
				unsavedQuestionChanges ? (unsavedQuestionChanges = false) : resetQuestion()
			"
			>{{ labels.lbl_geral_vincular }}</span
		>
	</div>
	<div class="body-wrap category" *ngIf="selectedTab === 'category'">
		<div class="tip">{{ labels.lbl_categoria_primeira_etapa_autoatendimento }}</div>

		<!-- <cpi-generic-form-gen
        [setGenericForm]="categoryForm">
        </cpi-generic-form-gen> -->

		<div class="add-category-container">
			<div class="dotted-input-container">
				<span>{{ labels.lbl_nome_nova_categoria }} *</span>
				<input
					[value]="newCategory[defaultCustomerLanguage]"
					(input)="newCategory[defaultCustomerLanguage] = $event.target.value" />
			</div>

			<div class="dotted-input-container">
				<div>
					<span>{{ labels.lbl_link_externo }}</span
					><fa-icon [icon]="icons.faQuestionCircle" [title]="labels.lbl_categoria_link_externo_sem_perguntas"></fa-icon>
				</div>
				<input [value]="newCategory.externUrl" (input)="newCategory.externUrl = $event.target.value" />
			</div>

			<div class="dotted-input-container">
				<span>{{ labels.lbl_visivel_no_mobile }}</span>
				<cpi-checkbox
					[value]="newCategory.mobile"
					[innerText]="newCategory.mobile == true ? labels.lbl_geral_sim : labels.lbl_geral_nao"
					(oValue)="newCategory.mobile = $event">
				</cpi-checkbox>
			</div>

			<div class="dotted-input-container">
				<span>{{ labels.lbl_geral_icone }}</span>
				<select (change)="newCategory.icon = $event.target.value">
					<option [value]="''">{{ labels.lbl_geral_selecione }}</option>
					<option [value]="icon.key" *ngFor="let icon of availableIcons | keyvalue">
						{{ labels[icon.value.label] ? labels[icon.value.label] : icon.value.label }}
					</option>
				</select>
			</div>
			<div class="icon-container" *ngIf="newCategory.icon">
				<span><fa-icon [icon]="availableIcons[newCategory.icon].icon"></fa-icon></span>
			</div>

			<div
				class="form-wrap form-row"
				(click)="
					otherLanguageNewCategory.classList.contains('open')
						? otherLanguageNewCategory.classList.remove('open')
						: otherLanguageNewCategory.classList.add('open')
				"
				#otherLanguageNewCategory>
				<span>{{ labels.lbl_outros_idiomas }}</span>
				<span
					><fa-icon [icon]="otherLanguageNewCategory.classList.contains('open') ? icons.faAngleUp : icons.faAngleDown"></fa-icon
				></span>
			</div>
			<div class="form-wrap" *ngIf="otherLanguageNewCategory.classList.contains('open')">
				<span class="tip"
					>{{ labels.lbl_nao_preencher_campo_idioma_adicionar }} ({{ labels[availableLanguages[defaultCustomerLanguage]] }})</span
				>
				<ng-container *ngFor="let language of availableLanguages | keyvalue">
					<div class="dotted-input-container" *ngIf="language.key != defaultCustomerLanguage">
						<span>{{ labels[language.value] }}</span>
						<input [value]="newCategory[language.key]" (input)="newCategory[language.key] = $event.target.value" />
					</div>
				</ng-container>
			</div>

			<div class="button" (click)="addCategory()">{{ labels.lbl_geral_adicionar }} {{ labels.lbl_asset_category }}</div>
		</div>

		<div class="category-card" *ngFor="let category of catalogCategory; let index = index">
			<div
				class="category-card-header"
				(click)="
					categoryCardHeader.classList.contains('open')
						? categoryCardHeader.classList.remove('open')
						: categoryCardHeader.classList.add('open')
				"
				#categoryCardHeader>
				<span>{{ category[ProfileService.userData().language.toLowerCase()] }}</span>
				<span>
					<fa-icon [icon]="categoryCardHeader.classList.contains('open') ? icons.faAngleUp : icons.faAngleDown"></fa-icon>
				</span>
			</div>
			<div class="category-card-body" *ngIf="categoryCardHeader.classList.contains('open')">
				<div class="dotted-input-container">
					<span>{{ labels[availableLanguages[defaultCustomerLanguage]] }} *</span>
					<input [value]="category[defaultCustomerLanguage]" (input)="category[defaultCustomerLanguage] = $event.target.value" />
				</div>

				<div class="dotted-input-container">
					<span>{{ labels.lbl_link_externo }}</span>
					<input [value]="category.externUrl" (input)="category.externUrl = $event.target.value" />
				</div>

				<div class="dotted-input-container">
					<span>{{ labels.lbl_visivel_no_mobile }}</span>
					<cpi-checkbox
						[value]="category.mobile"
						[innerText]="category.mobile == true ? labels.lbl_geral_sim : labels.lbl_geral_nao"
						(oValue)="category.mobile = $event">
					</cpi-checkbox>
				</div>

				<div class="dotted-input-container">
					<span>{{ labels.lbl_geral_icone }}</span>
					<select (change)="category.icon = $event.target.value">
						<option [value]="''" [selected]="!category.icon || category.icon === ''">{{ labels.lbl_geral_selecione }}</option>
						<option [value]="icon.key" [selected]="category.icon === icon.key" *ngFor="let icon of availableIcons | keyvalue">
							{{ labels[icon.value.label] ? labels[icon.value.label] : icon.value.label }}
						</option>
					</select>
				</div>
				<div class="icon-container" *ngIf="category.icon">
					<span><fa-icon [icon]="availableIcons[category.icon].icon"></fa-icon></span>
				</div>

				<div
					class="form-wrap form-row"
					(click)="
						otherLanguageOldCategory.classList.contains('open')
							? otherLanguageOldCategory.classList.remove('open')
							: otherLanguageOldCategory.classList.add('open')
					"
					#otherLanguageOldCategory>
					<span>{{ labels.lbl_outros_idiomas }}</span>
					<span
						><fa-icon
							[icon]="otherLanguageOldCategory.classList.contains('open') ? icons.faAngleUp : icons.faAngleDown"></fa-icon
					></span>
				</div>
				<div class="form-wrap" *ngIf="otherLanguageOldCategory.classList.contains('open')">
					<span class="tip"
						>{{ labels.lbl_nao_preencher_campo_idioma_adicionar }} ({{
							labels[availableLanguages[defaultCustomerLanguage]]
						}})</span
					>
					<ng-container *ngFor="let language of availableLanguages | keyvalue">
						<div class="dotted-input-container" *ngIf="language.key != defaultCustomerLanguage">
							<span>{{ labels[language.value] }}</span>
							<input [value]="category[language.key]" (input)="category[language.key] = $event.target.value" />
						</div>
					</ng-container>
				</div>

				<div class="button-container">
					<span
						(click)="confirmReset.classList.contains('confirmClick') ? deleteCategoryItem(index) : confirmButton(confirmReset)"
						#confirmReset
						><fa-icon [icon]="icons.faTrash"></fa-icon
					></span>
				</div>
			</div>
		</div>

		<div class="button-container">
			<div class="button" [ngClass]="{ disabled: isUpdatingCategory }" (click)="saveCategory()">
				{{ labels.lbl_geral_salvar }} {{ labels.lbl_asset_category }}
				<cpi-dot-bounce-loading-effect [color]="'var(--const-white)'" *ngIf="isUpdatingCategory"></cpi-dot-bounce-loading-effect>
			</div>
		</div>
	</div>

	<div class="body-wrap question" *ngIf="selectedTab === 'question'">
		<div class="tip">
			{{ labels.lbl_vinculacao_perguntas_respostas }}
		</div>
		<div class="add-question-container">
			<div class="dotted-input-container">
				<span>{{ labels.lbl_geral_nova }} {{ labels.lbl_geral_question }} *</span>
				<input
					[value]="newQuestion[defaultCustomerLanguage]"
					(input)="newQuestion[defaultCustomerLanguage] = $event.target.value" />
			</div>
			<div class="dotted-input-container">
				<span>Cod. *</span>
				<input [value]="newQuestion.cod" (input)="newQuestion.cod = $event.target.value" />
			</div>
			<div class="dotted-input-container">
				<span>{{ labels.lbl_informativo_da_pergunta }}</span>
				<textarea [value]="newQuestion['informative'][defaultCustomerLanguage]"></textarea>
			</div>

			<div
				class="form-wrap form-row"
				(click)="
					otherLanguageNewQuestion.classList.contains('open')
						? otherLanguageNewQuestion.classList.remove('open')
						: otherLanguageNewQuestion.classList.add('open')
				"
				#otherLanguageNewQuestion>
				<span>{{ labels.lbl_outros_idiomas }} ({{ labels.lbl_geral_question }})</span>
				<span
					><fa-icon [icon]="otherLanguageNewQuestion.classList.contains('open') ? icons.faAngleUp : icons.faAngleDown"></fa-icon
				></span>
			</div>
			<div class="form-wrap" *ngIf="otherLanguageNewQuestion.classList.contains('open')">
				<span class="tip"
					>{{ labels.lbl_nao_preencher_campo_idioma_adicionar }} ({{ labels[availableLanguages[defaultCustomerLanguage]] }})</span
				>
				<ng-container *ngFor="let language of availableLanguages | keyvalue">
					<div class="dotted-input-container" *ngIf="language.key != defaultCustomerLanguage">
						<span>{{ labels[language.value] }}</span>
						<input [value]="newQuestion[language.key]" (input)="newQuestion[language.key] = $event.target.value" />
					</div>
				</ng-container>
			</div>

			<div
				class="form-wrap form-row"
				(click)="
					otherLanguageNewQuestionInformative.classList.contains('open')
						? otherLanguageNewQuestionInformative.classList.remove('open')
						: otherLanguageNewQuestionInformative.classList.add('open')
				"
				#otherLanguageNewQuestionInformative>
				<span>{{ labels.lbl_outros_idiomas }} ({{ labels.lbl_geral_informativo }})</span>
				<span
					><fa-icon
						[icon]="
							otherLanguageNewQuestionInformative.classList.contains('open') ? icons.faAngleUp : icons.faAngleDown
						"></fa-icon
				></span>
			</div>
			<div class="form-wrap" *ngIf="otherLanguageNewQuestionInformative.classList.contains('open')">
				<span class="tip"
					>{{ labels.lbl_nao_preencher_campo_idioma_adicionar }} ({{ labels[availableLanguages[defaultCustomerLanguage]] }})</span
				>
				<ng-container *ngFor="let language of availableLanguages | keyvalue">
					<div class="dotted-input-container" *ngIf="language.key != defaultCustomerLanguage">
						<span>{{ labels[language.value] }}</span>
						<input
							[value]="newQuestion['informative'][language.key]"
							(input)="newQuestion['informative'][language.key] = $event.target.value" />
					</div>
				</ng-container>
			</div>

			<div class="button" (click)="addQuestion()">{{ labels.lbl_geral_adicionar }} {{ labels.lbl_geral_question }}</div>
		</div>

		<input
			[placeholder]="labels.lbl_geral_buscar + ' ' + labels.lbl_geral_questions"
			[value]="textFilterCatalogQuestion"
			(input)="textFilterCatalogQuestion = $event.target.value" />

		<div class="question-card" *ngFor="let question of catalogQuestion | callback: filterQuestionCallBack; let iindex = index">
			<div
				class="question-card-header"
				(click)="
					questionCardHeader.classList.contains('open')
						? questionCardHeader.classList.remove('open')
						: questionCardHeader.classList.add('open')
				"
				#questionCardHeader>
				<span>{{ question[ProfileService.userData().language.toLowerCase()] }}</span>
				<span>
					<fa-icon [icon]="questionCardHeader.classList.contains('open') ? icons.faAngleUp : icons.faAngleDown"></fa-icon>
				</span>
			</div>
			<div class="category-card-body" *ngIf="questionCardHeader.classList.contains('open')">
				<div class="dotted-input-container">
					<span>{{ labels[availableLanguages[defaultCustomerLanguage]] }} *</span>
					<input [value]="question[defaultCustomerLanguage]" (input)="question[defaultCustomerLanguage] = $event.target.value" />
				</div>
				<div class="dotted-input-container">
					<span>Cod. *</span>
					<input [value]="question.cod" (input)="question.cod = $event.target.value" />
				</div>
				<div class="dotted-input-container">
					<span>{{ labels.lbl_informativo_da_pergunta }}</span>
					<textarea
						[value]="question['informative'][defaultCustomerLanguage]"
						(input)="question['informative'][defaultCustomerLanguage] = $event.target.value"></textarea>
				</div>

				<div
					class="form-wrap form-row"
					(click)="
						otherLanguageOldQuestion.classList.contains('open')
							? otherLanguageOldQuestion.classList.remove('open')
							: otherLanguageOldQuestion.classList.add('open')
					"
					#otherLanguageOldQuestion>
					<span>{{ labels.lbl_outros_idiomas }} ({{ labels.lbl_geral_question }})</span>
					<span
						><fa-icon
							[icon]="otherLanguageOldQuestion.classList.contains('open') ? icons.faAngleUp : icons.faAngleDown"></fa-icon
					></span>
				</div>
				<div class="form-wrap" *ngIf="otherLanguageOldQuestion.classList.contains('open')">
					<span class="tip"
						>{{ labels.lbl_nao_preencher_campo_idioma_adicionar }} ({{
							labels[availableLanguages[defaultCustomerLanguage]]
						}})</span
					>
					<ng-container *ngFor="let language of availableLanguages | keyvalue">
						<div class="dotted-input-container" *ngIf="language.key != defaultCustomerLanguage">
							<span>{{ labels[language.value] }}</span>
							<input [value]="question[language.key]" (input)="question[language.key] = $event.target.value" />
						</div>
					</ng-container>
				</div>

				<div
					class="form-wrap form-row"
					(click)="
						otherLanguageOldQuestionInformative.classList.contains('open')
							? otherLanguageOldQuestionInformative.classList.remove('open')
							: otherLanguageOldQuestionInformative.classList.add('open')
					"
					#otherLanguageOldQuestionInformative>
					<span>{{ labels.lbl_outros_idiomas }} ({{ labels.lbl_geral_informativo }})</span>
					<span
						><fa-icon
							[icon]="
								otherLanguageOldQuestionInformative.classList.contains('open') ? icons.faAngleUp : icons.faAngleDown
							"></fa-icon
					></span>
				</div>
				<div class="form-wrap" *ngIf="otherLanguageOldQuestionInformative.classList.contains('open')">
					<span class="tip"
						>{{ labels.lbl_nao_preencher_campo_idioma_adicionar }} ({{
							labels[availableLanguages[defaultCustomerLanguage]]
						}})</span
					>
					<ng-container *ngFor="let language of availableLanguages | keyvalue">
						<div class="dotted-input-container" *ngIf="language.key != defaultCustomerLanguage">
							<span>{{ labels[language.value] }}</span>
							<input
								[value]="question['informative'][language.key]"
								(input)="question['informative'][language.key] = $event.target.value" />
						</div>
					</ng-container>
				</div>

				<div class="form-wrap form-row" (click)="selectedQuestionIndex = iindex; selectedTab = 'answer'" #addAnswerHeader>
					<span>{{ labels.lbl_geral_responses }}</span>
					<span>
						<fa-icon [icon]="icons.faAngleRight"></fa-icon>
					</span>
				</div>

				<div class="button-container">
					<span
						(click)="confirmReset.classList.contains('confirmClick') ? deleteQuestionItem(iindex) : confirmButton(confirmReset)"
						#confirmReset
						><fa-icon [icon]="icons.faTrash"></fa-icon
					></span>
				</div>
			</div>
		</div>

		<div class="button-container">
			<div class="button" [ngClass]="{ disabled: isUpdatingQuestion }" (click)="saveQuestion()">
				{{ labels.lbl_geral_salvar }} {{ labels.lbl_geral_questions }}
				<cpi-dot-bounce-loading-effect [color]="'var(--const-white)'" *ngIf="isUpdatingQuestion"></cpi-dot-bounce-loading-effect>
			</div>
		</div>
	</div>

	<div class="body-wrap answer" *ngIf="selectedTab === 'answer'">
		<div class="link-card-header">
			{{ labels.lbl_geral_responses }} {{ labels.lbl_slam_de }} "{{
				catalogQuestion[selectedQuestionIndex][defaultCustomerLanguage]
			}}"
		</div>

		<div class="add-answer-container">
			<div class="dotted-input-container">
				<span>{{ labels.lbl_geral_nova }} {{ labels.lbl_geral_response }} *</span>
				<input [value]="newAnswer[defaultCustomerLanguage]" (input)="newAnswer[defaultCustomerLanguage] = $event.target.value" />
			</div>

			<div class="dotted-input-container">
				<span>{{ labels.lbl_geral_icone }}</span>
				<select (change)="newAnswer.icon = $event.target.value">
					<option [value]="''">{{ labels.lbl_geral_selecione }}</option>
					<option [value]="icon.key" *ngFor="let icon of availableIcons | keyvalue">
						{{ labels[icon.value.label] ? labels[icon.value.label] : icon.value.label }}
					</option>
				</select>
			</div>
			<div class="icon-container" *ngIf="newAnswer.icon">
				<span><fa-icon [icon]="availableIcons[newAnswer.icon].icon"></fa-icon></span>
			</div>

			<div
				class="form-wrap form-row"
				(click)="
					otherLanguageNewAnswer.classList.contains('open')
						? otherLanguageNewAnswer.classList.remove('open')
						: otherLanguageNewAnswer.classList.add('open')
				"
				#otherLanguageNewAnswer>
				<span>{{ labels.lbl_outros_idiomas }}</span>
				<span
					><fa-icon [icon]="otherLanguageNewAnswer.classList.contains('open') ? icons.faAngleUp : icons.faAngleDown"></fa-icon
				></span>
			</div>
			<div class="form-wrap" *ngIf="otherLanguageNewAnswer.classList.contains('open')">
				<span class="tip"
					>{{ labels.lbl_nao_preencher_campo_idioma_adicionar }} ({{ labels[availableLanguages[defaultCustomerLanguage]] }})</span
				>
				<ng-container *ngFor="let language of availableLanguages | keyvalue">
					<div class="dotted-input-container" *ngIf="language.key != defaultCustomerLanguage">
						<span>{{ labels[language.value] }}</span>
						<input [value]="newAnswer[language.key]" (input)="newAnswer[language.key] = $event.target.value" />
					</div>
				</ng-container>
			</div>

			<div class="button" (click)="addAnswer(selectedQuestionIndex)">
				{{ labels.lbl_geral_adicionar }} {{ labels.lbl_geral_response }}
			</div>
		</div>

		<div class="answer-card" *ngFor="let answer of catalogQuestion[selectedQuestionIndex].answer; let jindex = index">
			<div class="answer-card-header" #answerCardHeader>
				<span>{{ answer[ProfileService.userData().language.toLowerCase()] }}</span>
				<span
					(click)="
						answerCardHeader.classList.contains('open')
							? answerCardHeader.classList.remove('open')
							: answerCardHeader.classList.add('open')
					">
					<fa-icon [icon]="answerCardHeader.classList.contains('open') ? icons.faAngleUp : icons.faAngleDown"></fa-icon>
				</span>
			</div>
			<div class="answer-card-body" *ngIf="answerCardHeader.classList.contains('open')">
				<div class="dotted-input-container" *ngFor="let language of availableLanguages | keyvalue">
					<span
						>{{ labels[language.value] }} <ng-container *ngIf="defaultCustomerLanguage === language.key"> *</ng-container></span
					>
					<input [value]="answer[language.key]" (input)="answer[language.key] = $event.target.value" />
				</div>

				<div class="dotted-input-container">
					<span>{{ labels.lbl_geral_icone }}</span>
					<select (change)="answer.icon = $event.target.value">
						<option [value]="''" [selected]="!answer.icon || answer.icon === ''">{{ labels.lbl_geral_selecione }}</option>
						<option [value]="icon.key" [selected]="answer.icon == icon.key" *ngFor="let icon of availableIcons | keyvalue">
							{{ labels[icon.value.label] ? labels[icon.value.label] : icon.value.label }}
						</option>
					</select>
				</div>
				<div class="icon-container" *ngIf="answer.icon">
					<span><fa-icon [icon]="availableIcons[answer.icon].icon"></fa-icon></span>
				</div>

				<div class="button-container">
					<span
						(click)="
							confirmReset.classList.contains('confirmClick')
								? deleteAnswerItem(selectedQuestionIndex, jindex)
								: confirmButton(confirmReset)
						"
						#confirmReset
						><fa-icon [icon]="icons.faTrash"></fa-icon
					></span>
				</div>
			</div>
		</div>

		<div class="button-container">
			<div class="button" [ngClass]="{ disabled: isUpdatingQuestion }" (click)="saveQuestion()">
				{{ labels.lbl_geral_salvar }} {{ labels.lbl_geral_questions }}
				<cpi-dot-bounce-loading-effect [color]="'var(--const-white)'" *ngIf="isUpdatingQuestion"></cpi-dot-bounce-loading-effect>
			</div>
		</div>
	</div>

	<div class="body-wrap link" *ngIf="selectedTab === 'link'">
		<div
			class="link-card-header"
			(click)="
				categoryLinkCardHeader.classList.contains('open')
					? categoryLinkCardHeader.classList.remove('open')
					: categoryLinkCardHeader.classList.add('open')
			"
			#categoryLinkCardHeader>
			<span>{{ labels.lbl_categorias }}</span>
			<span>
				<fa-icon [icon]="categoryLinkCardHeader.classList.contains('open') ? icons.faAngleUp : icons.faAngleDown"></fa-icon>
			</span>
		</div>
		<div class="link-card-body" *ngIf="categoryLinkCardHeader.classList.contains('open')">
			<ng-container *ngFor="let category of catalogCategory">
				<div class="link-card">
					<span>({{ labels.lbl_asset_category }}) - {{ category[defaultCustomerLanguage] }}</span>
					<ng-container *ngIf="!category.externUrl">
						<div class="dotted-input-container">
							<span>{{ labels.lbl_va_para }}</span>
							<select disabled>
								<option>{{ labels.lbl_geral_question }}</option>
							</select>
						</div>
						<div class="fend">
							<select (change)="linkCategoryQuestion(category.id, $event.target.value)">
								<option [value]="'-1'">{{ labels.lbl_geral_selecione }}</option>
								<ng-container *ngFor="let unlinkedQuestion of catalogQuestion">
									<option
										[value]="unlinkedQuestion.id"
										[selected]="unlinkedQuestion.id_predecessor == category.id"
										*ngIf="
											unlinkedQuestion.id_predecessor == category.id || !linkedQuestions.includes(unlinkedQuestion.id)
										">
										{{ unlinkedQuestion[defaultCustomerLanguage] }}
									</option>
								</ng-container>
							</select>
						</div>
					</ng-container>
					<ng-container *ngIf="category.externUrl">
						<div class="dotted-input-container">
							<span>{{ labels.lbl_va_para }}</span>
							<select disabled>
								<option>{{ labels.lbl_url_externa }}</option>
							</select>
						</div>
						<div class="fend">
							<input disabled [value]="category.externUrl" [title]="category.externUrl" />
						</div>
					</ng-container>
				</div>
			</ng-container>
		</div>

		<input
			[placeholder]="labels.lbl_geral_buscar + ' ' + labels.lbl_geral_questions"
			[value]="textFilterCatalogQuestion"
			(input)="textFilterCatalogQuestion = $event.target.value" />

		<ng-container *ngFor="let question of catalogQuestion | callback: filterQuestionCallBack; let iindex = index">
			<div
				class="link-card-header"
				(click)="
					questionLinkHeader.classList.contains('open')
						? questionLinkHeader.classList.remove('open')
						: questionLinkHeader.classList.add('open')
				"
				#questionLinkHeader>
				<span>({{ labels.lbl_geral_question }}) - {{ question[defaultCustomerLanguage] }}</span>
				<span>
					<fa-icon [icon]="questionLinkHeader.classList.contains('open') ? icons.faAngleUp : icons.faAngleDown"></fa-icon>
				</span>
			</div>

			<div class="link-card-body" *ngIf="questionLinkHeader.classList.contains('open')">
				<ng-container *ngFor="let answer of question.answer; let jindex = index">
					<div class="link-card">
						<span>({{ labels.lbl_geral_response }}) - {{ answer[defaultCustomerLanguage] }}</span>
						<div class="dotted-input-container">
							<span>{{ labels.lbl_va_para }}</span>
							<select (change)="answer.goTo = $event.target.value; cleanAnswerGoTo(iindex, jindex)">
								<option [value]="''" [selected]="answer.goTo === ''">{{ labels.lbl_geral_selecione }}</option>
								<option [value]="'question'" [selected]="answer.goTo === 'question'">
									{{ labels.lbl_geral_question }}
								</option>
								<option [value]="'externUrl'" [selected]="answer.goTo === 'externUrl'">{{ labels.lbl_url_externa }}</option>
								<option [value]="'template'" [selected]="answer.goTo === 'template'">Template</option>
								<option [value]="'kb'" [selected]="answer.goTo === 'kb'">KB</option>
							</select>
						</div>
						<div class="fend" *ngIf="answer.goTo === 'question'">
							<select (change)="linkAnswerQuestion(iindex, jindex, $event.target.value)">
								<option [value]="''">{{ labels.lbl_geral_selecione }}</option>
								<ng-container *ngFor="let unlinkedQuestion of catalogQuestion">
									<option
										[value]="unlinkedQuestion.id"
										[selected]="answer.next_question == unlinkedQuestion.id"
										*ngIf="
											unlinkedQuestion.id != question.id &&
											(answer.next_question == unlinkedQuestion.id || !linkedQuestions.includes(unlinkedQuestion.id))
										">
										{{ unlinkedQuestion[defaultCustomerLanguage] }}
									</option>
								</ng-container>
							</select>
						</div>
						<div class="fend" *ngIf="answer.goTo === 'externUrl'">
							<input [value]="answer.externUrl" [title]="answer.externUrl" (input)="answer.externUrl = $event.target.value" />
						</div>
						<div class="fend" *ngIf="answer.goTo === 'template'">
							<select (change)="answer.template = $event.target.value">
								<option [value]="''">{{ labels.lbl_geral_selecione }}</option>
								<option
									[value]="template.id"
									[selected]="answer.template == template.id"
									*ngFor="let template of availableTemplate">
									{{ template.name }}
								</option>
							</select>
						</div>
						<div class="fend" *ngIf="answer.goTo === 'kb'">
							<select (change)="answer.kb = $event.target.value">
								<option [value]="''">{{ labels.lbl_geral_selecione }}</option>
								<option [value]="kb.id" [selected]="answer.kb == kb.id" *ngFor="let kb of availableKb">
									{{ kb.name }}
								</option>
							</select>
						</div>
					</div>
				</ng-container>
			</div>
		</ng-container>

		<div class="button-container">
			<div class="button" [ngClass]="{ disabled: isUpdatingQuestion }" (click)="saveQuestion()">
				{{ labels.lbl_geral_salvar }} {{ labels.lbl_geral_vinculos
				}}<cpi-dot-bounce-loading-effect [color]="'var(--const-white)'" *ngIf="isUpdatingQuestion"></cpi-dot-bounce-loading-effect>
			</div>
		</div>
	</div>
</div>

<cpi-dot-bounce-loading-effect
	[color]="'var(--primary-color-1)'"
	*ngIf="
		isLoadingCustomerData || isLoadingLabels || isLoadingCategory || isLoadingQuestion || isLoadingTemplate || isLoadingKb
	"></cpi-dot-bounce-loading-effect>
